import { grey, primary, secondary } from './colors';
const white = '#ffffff'; // $color-white
const black = '#000000'; // $color-true-black

/**
 * Palette
 *
 * Demos:
 *
 * - [App bar](https://ui-packages.isbuildingluma.com/ui-core/customization/color/)
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/colors.html)
 */
const palette = {
  background: {
    default: primary[25],
    paper: white
  },
  common: {
    black,
    white
  },
  grey,
  primary,
  secondary,
  text: {
    disabled: grey[600],
    primary: grey[800]
  }
};
export default palette;